export default __webpack_public_path__ + "static/media/EF9I-WBU4AAOWWo.2bdc26bf.jpg";